import { css } from "../helpers/webComponents";

const styles: string = css`
    :host {
        background-color: #1D2434;
        border-top: 3px solid #3B4B62;
        color: white;
        display: flex;
        flex-direction: column;
        padding: 10px;
        position: absolute;
        z-index: 1;
        top: 10rem;
        right: 40rem;
        width: 33%;
        height: 50%;
    }

    .item-header {
        font-size: 1.2em;
        margin-bottom: 10px;
    }

    .item {
        padding: 20px 20px;
        border-radius: 5px;
        cursor: pointer;
    }
`;

export class ItemComponent extends HTMLElement {
    private items: { name: string; alias: string; id: number }[] = [];
    private isOpen: boolean = false;

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.items = [];
    }

    public set item(items: { name: string; alias: string; id: number }[]) {
        this.items = items;
        console.log("ItemComponent received items:", this.items);
        this.render();
    }

    public toggle(): void {
        this.isOpen = !this.isOpen;
        this.style.display = this.isOpen ? "flex" : "none";

        if (this.isOpen) {
            setTimeout(() => {
                this.isOpen = false;
                this.style.display = "none";
            }, 2000);
        }
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
        <style>${styles}</style>
        <div class="item-header">Item Acquired</div>
        <div class="item">
            ${this.items.length > 0
            ? this.items.map(item => `<div class="Item-Component">${item.name}</div>`).join("")
            : "<p>No items</p>"
        }
        </div>
    `;
    }
}
